import {Component, Input, OnInit} from '@angular/core';
import {MediumGroupDTO} from 'src/app/services/api/api';

@Component({
  selector: 'sb-comp-embedded-medium-groups',
  templateUrl: './sb-embedded-medium-groups.component.html',
  styleUrls: ['./sb-embedded-medium-groups.component.scss'],
  standalone: false,
})
export class SbEmbeddedMediumGroupsComponent implements OnInit {
  @Input() mediumGroups: MediumGroupDTO[];

  constructor() {}

  ngOnInit(): void {}
}
